import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Skeleton from '@mui/material/Skeleton';

import { CoreMultipleChoiceQuestionOption } from '@ts-core/modules/multipleChoiceExercises/types';

interface MultipleChoiceQuestionOptionInputProps {
  option?: CoreMultipleChoiceQuestionOption;
  loading?: boolean;
}

const MultipleChoiceQuestionOptionInput = (props: MultipleChoiceQuestionOptionInputProps) => {
  const { option, loading } = props;
  const intl = useIntl();

  const label = useMemo(() => {
    if (loading) {
      return <Skeleton width={180} />;
    }
    if (!option) {
      return intl.formatMessage({ id: 'noAnswerOption' });
    }
    return option.text;
  }, [loading, option, intl]);

  return (
    <FormControlLabel
      control={
        <Radio
          color="default"
          sx={{
            py: 1,
            px: 1.5,
          }}
        />
      }
      label={label}
      value={option?._id || 'none'}
    />
  );
};

export default MultipleChoiceQuestionOptionInput;
